import React from 'react'
import { NavLink } from 'react-router-dom';
import { formatPrice, CONSULTATION_FEE } from '../siteConfig';
import ProgramImage from './ProgramImage';

import programs from '../programs.json';

function Programs() {
    return (
        <section className="services-area" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/parallax-background/background-services.jpg)`}}>
            <div className="container">
                <div className="sec-title text-center">
                    <div className="title clr-white">Programs</div>
                    <div className="dector thm-bg-clr center"></div>
                </div>
                <div className="service-grid">
                    { programs.map((program) => {
                        const price = <>1 Month: &#8377; {formatPrice(program.month1)}/- 3 Months: &#8377; {formatPrice(program.month3)}/-</>;

                        return <div key={program.name} className="single-service-item">
                            {/* One link around the whole card. The title and
                                "Read More" inside are plain text — nesting links
                                is invalid and made a screen reader announce the
                                same destination three times per card. */}
                            <NavLink
                                to="/programs"
                                className="service-card-link"
                                aria-label={`${program.name} — programme details`}
                            >
                                <div className="inner-content">
                                    <div className="title-holder top">
                                        <div className="icon">
                                            <span className="icon-fruit thm-clr"></span>
                                        </div>
                                        <div className="title">
                                            <h3>{program.name}</h3>
                                            <span>{price}</span>
                                        </div>
                                    </div>
                                    <div className="img-holder">
                                        <ProgramImage program={program} />
                                        {/* Hover-only enhancement; hidden without a
                                            pointer, and it repeats the card text. */}
                                        <div className="overlay-style-one" aria-hidden="true">
                                            <div className="box">
                                                <div className="content">
                                                    <div className="text-holder">
                                                        <div className="title-holder">
                                                            <div className="icon">
                                                                <span className="icon-fruit thm-clr"></span>
                                                            </div>
                                                            <div className="title">
                                                                <h3>{program.name}</h3>
                                                                <span>{price}</span>
                                                            </div>
                                                        </div>
                                                        <div className="text">
                                                            <p>{program.description.substr(0, 100)}...</p>
                                                            <span className="btn-two"><span className="icon-arrows-4"></span>Read More</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    })}
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="service-bottom-text">
                            <p className="consultation-fee">
                                <span className="consultation-fee-label">Consultation Fee</span>
                                <span className="consultation-fee-amount">&#8377; {formatPrice(CONSULTATION_FEE)}/-</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="service-bottom-button clearfix">
                            <NavLink to="/contact">
                                <div className="icon-box-one">
                                    <span className="icon-two one"></span>
                                </div>
                                <div className="icon-box-two">
                                    <span className="icon-arrows-3 two"></span>
                                </div>
                                Request for Consultation
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Programs
